function Spacer() { // 꽉 채우기
    return(
        <div style={{marginLeft: 'auto', marginRight: 'auto'}}>
        </div>
    );
}

export default Spacer;